<td-connect-cta *ngIf="wallet === null"></td-connect-cta>

<td-bulk-buy [names]="data.names" *ngIf="wallet && data" [acquisitionInfo]="data.acquisitionInfos" [wallet]="wallet" (bought)="domainsBought()"></td-bulk-buy>
